module.exports = __webpack_public_path__ + "static/media/banner3.20aaee19.jpg";